import serpFiltersModal from "./filtersModal";
import {MitulaSerpPageData} from "../SerpPage";
import {EventBus} from "../../../../common/ts/events/EventBus";
import eventHandlers from "./eventHandlers";
import {isDesktopDevice} from "../../device";
import operationTypeSelect from "../../components/userSearch/operationTypeSelect";
import dom from "../../../../common/ts/core/dom";
import location from "../../../../common/ts/core/location";
import propertyTypeSelect from "../../components/userSearch/propertyTypeSelect";
import {FiltersSubmittedEvent} from "./events";
import tracking from "../../../../common/ts/core/tracking";
import {getFormDataSubmittingInFilterBar, getTrackingFormData} from "./filterFormData";
import {FILTERS_BAR_FORM_SELECTOR, FILTERS_MODAL_FORM_SELECTOR} from "../../../../common/ts/serp/filters/constants";
import {WlSubmit} from "../../../../common/ts/webcomponents/events/WlSubmit";
import freeTextInputFilterComponent from "./freeTextInput/freeTextInputFilterComponent";
import geoChildrenSelectorFiltersComponent from "./geoChildrenSelectorFiltersComponent";
import {GetNumberOfListingRequestEvent} from "../../../../common/ts/core/filters/GetNumberOfListingsAjax";
import {WlTreeItem} from "../../../../common/ts/webcomponents/tree/tree.component";
import {WlRadioButton} from "../../../../common/ts/webcomponents/radioButton/radioButton.component";
import {WlChange} from "../../../../common/ts/webcomponents/events/WlChange";
import {WlCheckbox} from "../../../../common/ts/webcomponents/checkbox/checkbox.component";

const eventBus: EventBus = EventBus.getInstance();
const SUBMIT_BUTTON_ID = "apply-modal-button";

function init(pageData: MitulaSerpPageData) {
    eventHandlers.init();
    serpFiltersModal.init(eventBus, pageData);
    freeTextInputFilterComponent.init();
    geoChildrenSelectorFiltersComponent.init(pageData.pageviewId);
    registerSubmitButtonFiltersListener(pageData);
    subscribeSubmitForDropDownFilters();
    subscribeGetNumberOfListingsOnFilterChange()
}

function emitSubmit(e: CustomEvent) {
    e.preventDefault();
    const searchParams = new URLSearchParams(location.getQueryParams());
    const formData = getFormDataSubmittingInFilterBar()

    eventBus.emitMany([
        new FiltersSubmittedEvent({
            formData,
            searchParams,
            type: FiltersSubmittedEvent.FORM_TYPE
        }),
        new tracking.TrackWebTrackingEvent({
            type: "FiltersUpdated",
            serpUrl: window.location.href,
            filters: getTrackingFormData(formData, searchParams)
        })
    ])
}

function emitGetNumberOfListings(e: CustomEvent) {
    eventBus.emit(
        new GetNumberOfListingRequestEvent(
            {
                buttonId: SUBMIT_BUTTON_ID,
            })
    )
}

function subscribeSubmitForDropDownFilters() {
    const filtersBarForm = dom.select(FILTERS_BAR_FORM_SELECTOR) as HTMLFormElement;

    filtersBarForm.querySelectorAll(".js_filter_submit")
        .forEach((element: Node) => (element as HTMLElement).addEventListener(WlSubmit.type, emitSubmit as EventListener))

}

function subscribeGetNumberOfListingsOnFilterChange() {
    dom.select("#filters-button")?.addEventListener("click", emitGetNumberOfListings as EventListener);
    const filtersModalForm = dom.select(FILTERS_MODAL_FORM_SELECTOR) as HTMLFormElement;
    filtersModalForm.querySelectorAll("div[class*='modal-filter-option-']").forEach((element: Node) => {
            let htmlElement = element as HTMLElement;

            htmlElement.querySelectorAll("input").forEach((input: HTMLInputElement) =>
                input.addEventListener('change', emitGetNumberOfListings as EventListener)
            )
            // @ts-ignore
            htmlElement.querySelectorAll("wl-checkbox").forEach((check: WlCheckbox) =>
                check.addEventListener(WlChange.type, emitGetNumberOfListings as EventListener)
            )
            // @ts-ignore
            htmlElement.querySelectorAll("wl-tree-item").forEach((check: WlTreeItem) =>
                check.addEventListener('change', emitGetNumberOfListings as EventListener)
            )
            // @ts-ignore
            htmlElement.querySelectorAll("wl-radio-button").forEach((radio: WlRadioButton) =>
                radio.addEventListener(WlChange.type, emitGetNumberOfListings as EventListener)
            )
        }
    );

}

function registerSubmitButtonFiltersListener(pageData: MitulaSerpPageData) {
    eventBus.emit(new dom.AddClickListenerEvent({
        selector: "#priceRangeFilter_apply",
        listener: emitSubmit
    }));

    eventBus.emit(new dom.AddClickListenerEvent({
        selector: ".js_free-text-submit-button",
        listener: emitSubmit
    }));

    if (isDesktopDevice(pageData.device)) {
        operationTypeSelect.init(FILTERS_BAR_FORM_SELECTOR);
        propertyTypeSelect.init(pageData.propertyType);
    }
}


export default {
    init,
}
